(function () {
  function slidesOf(track) {
    return Array.from(track.querySelectorAll('.product-gallery__slide'));
  }

  function columnsOf(root) {
    const raw = getComputedStyle(root).getPropertyValue('--pg-columns').trim();
    const n = parseInt(raw, 10);
    return Number.isFinite(n) && n > 0 ? n : 1;
  }

  function maxIndex(track) {
    const slides = slidesOf(track);
    if (slides.length < 2) return 0;
    const origin = slides[0].offsetLeft;
    const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
    let last = 0;
    for (let i = 0; i < slides.length; i += 1) {
      if (slides[i].offsetLeft - origin <= maxScroll + 1) last = i;
    }
    return last;
  }

  function indexFromScroll(track) {
    const slides = slidesOf(track);
    if (!slides.length) return 0;
    const origin = slides[0].offsetLeft;
    const x = track.scrollLeft + origin;
    let best = 0;
    let bestDist = Infinity;
    for (let i = 0; i < slides.length; i += 1) {
      const dist = Math.abs(slides[i].offsetLeft - x);
      if (dist < bestDist) {
        bestDist = dist;
        best = i;
      }
    }
    return best;
  }

  function scrollLeftForIndex(track, index) {
    const slides = slidesOf(track);
    if (!slides.length) return 0;
    const origin = slides[0].offsetLeft;
    const safe = Math.max(0, Math.min(slides.length - 1, index));
    return Math.max(0, slides[safe].offsetLeft - origin);
  }

  function syncButtons(root, index, last) {
    const prev = root.querySelector('button[name="previous"]');
    const next = root.querySelector('button[name="next"]');
    if (!prev || !next) return;

    if (index <= 0) prev.setAttribute('disabled', 'disabled');
    else prev.removeAttribute('disabled');

    if (index >= last) next.setAttribute('disabled', 'disabled');
    else next.removeAttribute('disabled');
  }

  function init(root) {
    if (!root || root.dataset.pgReady === 'true') return;
    const track = root.querySelector('.product-gallery__track');
    const prev = root.querySelector('button[name="previous"]');
    const next = root.querySelector('button[name="next"]');
    if (!track) return;

    root.dataset.pgReady = 'true';

    let targetIndex = 0;
    let scrollEndTimer = 0;

    const slider = root.querySelector('slider-component');
    if (slider) {
      slider.onButtonClick = function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();
      };
    }

    function lastIndex() {
      return maxIndex(track);
    }

    function step() {
      return columnsOf(root);
    }

    function goTo(index, behavior) {
      const last = lastIndex();
      targetIndex = Math.max(0, Math.min(last, index));
      syncButtons(root, targetIndex, last);

      track.style.scrollSnapType = 'none';
      track.scrollTo({
        left: scrollLeftForIndex(track, targetIndex),
        behavior: behavior || 'smooth',
      });

      window.clearTimeout(scrollEndTimer);
      scrollEndTimer = window.setTimeout(() => {
        const exact = scrollLeftForIndex(track, targetIndex);
        if (Math.abs(track.scrollLeft - exact) > 1) {
          track.scrollTo({ left: exact, behavior: 'auto' });
        }
        track.style.scrollSnapType = '';
        syncButtons(root, targetIndex, lastIndex());
      }, 320);
    }

    function onPrev(event) {
      event.preventDefault();
      event.stopPropagation();
      goTo(targetIndex - step(), 'smooth');
    }

    function onNext(event) {
      event.preventDefault();
      event.stopPropagation();
      goTo(targetIndex + step(), 'smooth');
    }

    if (prev) prev.addEventListener('click', onPrev, true);
    if (next) next.addEventListener('click', onNext, true);

    track.addEventListener('scrollend', () => {
      window.clearTimeout(scrollEndTimer);
      targetIndex = indexFromScroll(track);
      track.style.scrollSnapType = '';
      syncButtons(root, targetIndex, lastIndex());
    });

    window.addEventListener('resize', () => {
      targetIndex = Math.min(targetIndex, lastIndex());
      goTo(targetIndex, 'auto');
    });

    targetIndex = indexFromScroll(track);
    syncButtons(root, targetIndex, lastIndex());
  }

  function initAll() {
    document.querySelectorAll('.product-gallery').forEach(init);
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector?.('.product-gallery') || event.target;
    if (root && root.classList && root.classList.contains('product-gallery')) {
      root.dataset.pgReady = '';
      init(root);
    } else {
      initAll();
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
